$(function () {
  let header = $('.js-header');

  $(window).scroll(function () {
    let currentScroll = $(window).scrollTop();

    currentScroll > 0 ? header.addClass('header_scroll') : header.removeClass('header_scroll');
  });

  $('.js-burger').click(function () {
    $(this).toggleClass('burger_active');
    if ($(this).hasClass('burger_active')) {
      $('body').removeClass('o-hidden');
    } else {
      $('body').addClass('o-hidden');
    }
    header.toggleClass('header_active');
    $('.header__content').toggleClass('header__content_active');
    $('body').toggleClass('o-hidden');
  });
})